"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.nodeHttpXHROverride = {
    sendPOST: function (payload, onComplete) {
        var https = require("https");
        var options = {
            method: "POST",
            headers: __assign(__assign({}, payload.headers), { "Content-Type": "application/json", "Content-Length": Buffer.byteLength(payload.data) })
        };
        var req = https.request(payload.urlString, options, function (res) {
            res.on("data", function (responseData) {
                onComplete(res.statusCode, res.headers, responseData.toString());
            });
        });
        req.write(payload.data);
        req.end();
    }
};
//# sourceMappingURL=NodeXHROverride.js.map